import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { TagItem } from 'src/types/TagItem';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import LevelIconSvg from 'public/icons/Level.svg';
import RoleIconSvg from 'public/icons/Role.svg';

import styles from './ContentOverviewAudienceContainer.module.css';

const { NursingRolesTagFolderId, NursingLevelsTagFolderId } = sitecoreIds.Items;

type ContentOverviewAudienceContainerProps = {
	wildCardContentId: string | undefined;
	defaultAudienceText: Field<string>;
	tags: TagItem[];
};

export default function ContentOverviewAudienceContainer(props: ContentOverviewAudienceContainerProps): JSX.Element {
	const nursingRoles = props.tags.filter((tag) => tag.parentId === NursingRolesTagFolderId);
	const nursingLevels = props.tags.filter((tag) => tag.parentId === NursingLevelsTagFolderId);

	const overviewAudienceContainer = ({ IconSvg, resource }: { IconSvg: React.ReactNode; resource: TagItem }) => {
		return (
			<div className={styles.overviewAudienceContainer} key={resource.id}>
				<div className={styles.overviewAudienceContainerImage}>{IconSvg}</div>
				<div className={styles.overviewAudienceContainerText}>
					<Text tag="p" field={resource.fields.Title} className={styles.overviewAudienceContainerResource} />
				</div>
			</div>
		);
	};

	return (
		<FieldEditFrame
			itemId={props?.wildCardContentId ?? undefined}
			fields={['Tags', 'DefaultAudienceText', 'RoleText', 'LevelText']}
			header="Edit Audience"
		>
			<EditorHelp text={'Click here to select the audience'} />
			<div className={styles.contentOverviewAudienceContainer}>
				{nursingRoles?.length > 0 &&
					nursingRoles.map((nursingRole) =>
						overviewAudienceContainer({
							IconSvg: <RoleIconSvg />,
							resource: nursingRole,
						})
					)}

				{nursingLevels?.length > 0 &&
					nursingLevels.map((nursingLevel) =>
						overviewAudienceContainer({
							IconSvg: <LevelIconSvg />,
							resource: nursingLevel,
						})
					)}

				{nursingRoles?.length <= 0 && nursingLevels?.length <= 0 && (
					<Text tag="p" className={styles.overviewAudienceContainerText} field={props.defaultAudienceText} />
				)}
			</div>
		</FieldEditFrame>
	);
}
